import getTreeTradeFailure from './getTreeTrade/failure';
import getTreeTradeRequest from './getTreeTrade/request';
import getTreeTradeSuccess from './getTreeTrade/success';

const reducers = {
  getTreeTradeFailure,
  getTreeTradeRequest,
  getTreeTradeSuccess,
};

export default reducers;
